export const getCookie = (): Cookie => {
  return document.cookie.split(';').reduce((res, c) => {
    const [key, val] = c.trim().split('=').map(decodeURIComponent);
    try {
      return Object.assign(res, { [key]: JSON.parse(val) });
    } catch (e) {
      return Object.assign(res, { [key]: val });
    }
  }, {});
};

export const setCookieValue = (
  key: string,
  value: string | null,
  duration: number = 86400000
) => {
  let expires = new Date();
  expires.setTime(expires.getTime() + duration); //24 hours
  document.cookie =
    key +
    '=' +
    value +
    ';path=/;domain=.tangerineglobal.com;expires=' +
    expires.toUTCString();
};
